import React, { useEffect } from "react";
import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import * as Styled from "./styled";

import Tab from "./components/tab";
import RemoteData from "./components/tabs/jobRole/remoteindex";
import TeamData from "./components/tabs/jobRole/index"
import Approved from "./components/tabs/approved";
import Requests from "./components/tabs/requests";
import Sidemenu from "../../components/sidemenu";
import { functionService } from "../../lib/functions";



const Coffeeeplus = () => {
  let { role } = useParams();
  const [activeTab, setActiveTab] = useState(1);

  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Styled.ColumnDiv>
        <Tab activeTab={activeTab} setActiveTab={setActiveTab} />
        <div style={{ overflow: "scroll", padding: "0px 20px" }}>
          {activeTab === 1  &&(role==="TEAM"?<TeamData />:<RemoteData/>)}
          {activeTab === 2 && <Requests setActiveTab={setActiveTab} />}
          {activeTab === 3 && <Approved />}
        </div>
      </Styled.ColumnDiv>
    </Styled.MainDiv>
  );
};

export default Coffeeeplus;
